import React, { useEffect } from "react";
import ReactGA from "react-ga4";

import preAssembleia from "../../../assets/landingpage/unicred/pre-assembleia.png";
import iconDownload from "../../../assets/landingpage/unicred/download.png";
import iconInstagram from "../../../assets/landingpage/unicred/instagram.png";
import iconFacebook from "../../../assets/landingpage/unicred/facebook.png";
import iconTwitter from "../../../assets/landingpage/unicred/twitter.png";
import iconYoutube from "../../../assets/landingpage/unicred/youtube.png";
import iconLinkedin from "../../../assets/landingpage/unicred/linkedin.png";
import iconWhatsapp from "../../../assets/landingpage/unicred/whatsapp.png";
import unicredLogo from "../../../assets/landingpage/unicred/unicred.png";

import "./styles.scss";

function UnicredUniao({ domain }) {
  useEffect(() => {
    ReactGA.send({
      hitType: "event",
      eventCategory: "landingPage",
      eventAction: "access",
      eventLabel: domain,
    });
  }, []);

  return (
    <div className="lp-unicred">
      <div className="section-1">
        <div className="section-1-container wrap">
          <div className="section-1-image">
            <div className="section-1-position">
              <img src={preAssembleia} />
            </div>
          </div>
          <div className="section-1-info section-1-info-custom section-1-info-custom-uniao">
            <div className="section-1-info-title section-1-info-title-custom">
              <h2>PRÉ-ASSEMBLEIA</h2>
              <h3>UNICRED UNIÃO 2026</h3>
            </div>

            <p>
              Boas-vindas!<br /><br />
              Sua participação é importante para fortalecer a Unicred União e assegurar decisões que atendam aos interesses da cooperativa e dos cooperados.<br /> Aqui, você fica por dentro do essencial para chegar bem-informado à Assembleia Geral Ordinária (AGO).
            </p>
          </div>
        </div>
      </div>

      <div className="section-form" style={{ backgroundColor: "#3d3935" }}>
        <div className="wrap">
          <div className="section-info-uniao">
            <h3>PARTICIPE DA AGO</h3>
            <p style={{ marginBottom: 20 }}>
              <strong>Data:</strong> 20 de abril de 2026<br />
              <strong>Horário:</strong> 9h (terceira convocação)<br />
              <strong>Formato:</strong> Digital e com transmissão em todas as agências
            </p>
            <p>Acesse e vote pelo:</p>
            <ul style={{ margin: "30px 0" }}>
              <li>Internet Banking</li>
              <li>Aplicativo Unicred Mobile → ícone <strong>“Assembleias”</strong></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo" style={{ backgroundColor: "#332f2a" }}>
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title">Mensagem <span>da Presidência</span></h1>
            <p>Assista ao vídeo do<br/ > presidente, Dr. Mauro Marquiotti.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-2026-mauro-marquiotti-mensagem.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo">
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title">Mensagem <span>da Diretoria</span></h1>
            <p>Assista ao vídeo do<br /> diretor executivo, Marcelo Vieira Martins.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-2026-marcelo-vieira-martins.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo" style={{ backgroundColor: "#332f2a" }}>
        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title">Confira as <span>realizações de 2025</span></h1>
            <p>Veja um resumo dos destaques do ano. Sua participação foi fundamental para os resultados alcançados.</p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-confira-as-realizacoes-de-2025.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-form" style={{ backgroundColor: "#d6d1ca", color: "#2f2b28" }}>
        <div className="wrap">
          <div className="section-info-uniao">
            <h3 style={{ color: "#2f2b28" }}>Agradecemos por fazer parte deste momento</h3>
            <p style={{ color: "#2f2b28" }}>
              Com a sua participação, seguimos fortalecendo a Unicred União e construindo um futuro ainda mais sólido.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="section-form" style={{ backgroundColor: "#d6d1ca", color: "#2f2b28" }}>
        <div className="wrap">
          <div className="section-form-info section-form-info-uniao">
            <p style={{ paddingLeft: 0, maxWidth: 'none', fontStyle: "italic" }}>
              "As leis que embasam os assuntos que serão debatidos na Assembleia são a Lei 5.764/71 e a Lei Complementar 130/2009. Já os Normativos do Banco Central do Brasil são a Resolução CMN 5051/2022, a Resolução CMN 4595/2017. Acesse as respectivas leis e normativos nos seguintes links: <a href="https://www.planalto.gov.br/ccivil_03/leis/l5764.htm" target="_blank">L5764</a>; <a href="https://www.planalto.gov.br/ccivil_03/LEIS/LCP/Lcp130.htm" target="_blank">Lcp 130</a> e <a href="https://www.bcb.gov.br/estabilidadefinanceira/buscanormas" target="_blank">Busca de normas</a>."
            </p>
          </div>
        </div>
      </div> */}

      {/* <div className="section-links" style={{ backgroundColor: "#332f2a" }}>
        <div className="section-links-container section-links-container-uniao wrap">
          <div>
            <ul className="links2" style={{ maxWidth: "100%" }}>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2025/uniao/unicred-uniao-edital-convocacao-age-2025.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Edital de Convocação
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2025/uniao/unicred-uniao-estatuto-social-proposta-de-adaptacao-ao-pada%CC%83o-sistemico.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Estatuto Social
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2025/uniao/unicred-uniao-politica-de-renovacao-do-conselho-de-administracao.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política de Renovação do Conselho de Administração
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2025/uniao/unicred-uniao-politica-sistemica-de-conformidade.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política Sistêmica de Conformidade
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2025/uniao/unicred-uniao-politica-sistemica-de-governanca-corporativa.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política Sistêmica de Governança Corporativa
                </a>
              </li>

              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2023/manual-unicred-web-2023.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso computador
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2023/manual-unicred-mobile-2023.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso celular
                </a>
              </li>
            </ul>
          </div>

          <div className="section-links-info">
            <h1>Ficou com alguma dúvida ou quer enviar alguma sugestão?</h1>
            <p>Converse com seu gerente de relacionamento ou envie diretamente no canal de contato com o Presidente da cooperativa: <a href="mailto:falecomapresidencia@unicred.com.br">falecomapresidencia@unicred.com.br</a></p>
          </div>
        </div>
      </div> */}

      <div className="section-links" style={{ backgroundColor: "#3d3935" }}>
        <div className="section-links-container wrap">
          <div>
            <ul className="links2">
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-edital.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Edital
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-demonstracoes-financeiras.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Demonstrações Financeiras
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-politica-de-auditoria-interna.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política de Auditoria Interna
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-uniao-politica-sistemica-de-remuneracao.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política Sistêmica de Remuneração
                </a>
              </li>
            </ul>
          </div>

          <div>
            <ul className="links2">
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-politica-sistemica-de-desenvolvimento-avaliacao-e-sucessao-da-alta-administracao.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política Sistêmica de Desenvolvimento, Avaliação e Sucessão da Alta Administração
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-web.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso computador
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-mobile.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso celular
                </a>
              </li>
            </ul>
          </div>

          <div className="section-links-info">
            <h1>Ficou com alguma dúvida ou quer enviar alguma sugestão?</h1>
            <p>
              Envie sua pergunta ou sugestão para <a href="mailto:falecomapresidencia@unicred.com.br">falecomapresidencia@unicred.com.br</a> ou converse diretamente com seu <strong>Gerente de Relacionamento</strong>.
            </p>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-container wrap">
          <div className="footer-info">
            <a className="footer-info-site" href="https://unicred.com.br" target="_blank">unicred.com.br</a>

            <div className="footer-info-box">
              <h2>Agência Mais — Atendimento 24/7</h2>
              <p>4007-2440</p>
              <p>Atendimento todos os dias, a qualquer hora.</p>
            </div>
          </div>

          <div className="footer-social">
            <div className="footer-social-box">
              <h2>Siga a Unicred nas redes sociais</h2>
              <ul className="social-list">
                <li><a href="https://www.instagram.com/unicredbrasil/" title="Instagram" target="_blank"><img src={iconInstagram} alt="Instagram" /></a></li>
                <li><a href="https://www.facebook.com/unicredbrasil" title="Facebook" target="_blank"><img src={iconFacebook} alt="Facebook" /></a></li>
                <li><a href="https://twitter.com/unicredbrasil" title="Twitter" target="_blank"><img src={iconTwitter} alt="Twitter" /></a></li>
                <li><a href="https://www.youtube.com/channel/UCdowVMAIRENRC2VH0_gcdww" title="Youtube" target="_blank"><img src={iconYoutube} alt="Youtube" /></a></li>
                <li><a href="https://br.linkedin.com/company/unicredbr" title="Linkedin" target="_blank"><img src={iconLinkedin} alt="Linkedin" /></a></li>
              </ul>
            </div>

            <div className="footer-logo">
              <img src={unicredLogo} alt="Unicred" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnicredUniao;
